module.exports = ".form-group{\r\n    display: inline;\r\n}\r\n.float-right{\r\n    float: right;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/view/rpt-form/report-list/licence-pendding-list/licence-pendding-list.component.css
// module id = ./src/app/pages/view/rpt-form/report-list/licence-pendding-list/licence-pendding-list.component.css
// module chunks = main